import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Vector from "../imagem/Vector.svg";
import Medalha_romance_1 from "../imagem/Medalha_romance_1.svg";
import Medalha_romance_1_bloq from "../imagem/Medalha_romance_1_bloq.svg";
import Medalha_romance_2 from "../imagem/Medalha_romance_2.svg";
import Medalha_romance_2_bloq from "../imagem/Medalha_romance_2_bloq.svg";
import Medalha_romance_3 from "../imagem/Medalha_romance_3.svg";
import Medalha_romance_3_bloq from "../imagem/Medalha_romance_3_bloq.svg";
import Medalha_terror_1 from "../imagem/Medalha_terror_1.svg";
import Medalha_terror_1_bloq from "../imagem/Medalha_terror_1_bloq.svg";
import Medalha_terror_2 from "../imagem/Medalha_terror_2.svg";
import Medalha_terror_2_bloq from "../imagem/Medalha_terror_2_bloq.svg";
import Medalha_terror_3 from "../imagem/Medalha_terror_3.svg";
import Medalha_terror_3_bloq from "../imagem/Medalha_terror_3_bloq.svg";
import Medalha_fantasia_1 from "../imagem/Medalha_fantasia_1.svg";
import Medalha_fantasia_1_bloq from "../imagem/Medalha_fantasia_1_bloq.svg";
import Medalha_fantasia_2 from "../imagem/Medalha_fantasia_2.svg";
import Medalha_fantasia_2_bloq from "../imagem/Medalha_fantasia_2_bloq.svg";
import Medalha_fantasia_3 from "../imagem/Medalha_fantasia_3.svg";
import Medalha_fantasia_3_bloq from "../imagem/Medalha_fantasia_3_bloq.svg";
import Medalha_misterio_1 from "../imagem/Medalha_misterio_1.svg";
import Medalha_misterio_1_bloq from "../imagem/Medalha_misterio_1_bloq.svg";
import Medalha_misterio_2 from "../imagem/Medalha_misterio_2.svg";
import Medalha_misterio_2_bloq from "../imagem/Medalha_misterio_2_bloq.svg";
import Medalha_misterio_3 from "../imagem/Medalha_misterio_3.svg";
import Medalha_misterio_3_bloq from "../imagem/Medalha_misterio_3_bloq.svg";
import Medalha_fabula_1 from "../imagem/Medalha_fabula_1.svg";
import Medalha_fabula_1_bloq from "../imagem/Medalha_fabula_1_bloq.svg";
import Medalha_fabula_2 from "../imagem/Medalha_fabula_2.svg";
import Medalha_fabula_2_bloq from "../imagem/Medalha_fabula_2_bloq.svg";
import Medalha_fabula_3 from "../imagem/Medalha_fabula_3.svg";
import Medalha_fabula_3_bloq from "../imagem/Medalha_fabula_3_bloq.svg";
import Medalha_suspense_1 from "../imagem/Medalha_suspense_1.svg";
import Medalha_suspense_1_bloq from "../imagem/Medalha_suspense_1_bloq.svg";
import Medalha_suspense_2 from "../imagem/Medalha_suspense_2.svg";
import Medalha_suspense_2_bloq from "../imagem/Medalha_suspense_2_bloq.svg";
import Medalha_suspense_3 from "../imagem/Medalha_suspense_3.svg";
import Medalha_suspense_3_bloq from "../imagem/Medalha_suspense_3_bloq.svg";
import BarraDeProgresso from "../Componets/BarraDeProgresso";

function Medalhas({ open, onClose, genero, nivel, pontuacao, pontuacaoMax }) {
  const medalhas = {
    Romance: {
      imgNivel1: Medalha_romance_1,
      imgNivel1Bloq: Medalha_romance_1_bloq,
      imgNivel2: Medalha_romance_2,
      imgNivel2Bloq: Medalha_romance_2_bloq,
      imgNivel3: Medalha_romance_3,
      imgNivel3Bloq: Medalha_romance_3_bloq,
    },
    Terror: {
      imgNivel1: Medalha_terror_1,
      imgNivel1Bloq: Medalha_terror_1_bloq,
      imgNivel2: Medalha_terror_2,
      imgNivel2Bloq: Medalha_terror_2_bloq,
      imgNivel3: Medalha_terror_3,
      imgNivel3Bloq: Medalha_terror_3_bloq,
    },
    Fantasia: {
      imgNivel1: Medalha_fantasia_1,
      imgNivel1Bloq: Medalha_fantasia_1_bloq,
      imgNivel2: Medalha_fantasia_2,
      imgNivel2Bloq: Medalha_fantasia_2_bloq,
      imgNivel3: Medalha_fantasia_3,
      imgNivel3Bloq: Medalha_fantasia_3_bloq,
    },
    Mistério: {
      imgNivel1: Medalha_misterio_1,
      imgNivel1Bloq: Medalha_misterio_1_bloq,
      imgNivel2: Medalha_misterio_2,
      imgNivel2Bloq: Medalha_misterio_2_bloq,
      imgNivel3: Medalha_misterio_3,
      imgNivel3Bloq: Medalha_misterio_3_bloq,
    },
    Fábula: {
      imgNivel1: Medalha_fabula_1,
      imgNivel1Bloq: Medalha_fabula_1_bloq,
      imgNivel2: Medalha_fabula_2,
      imgNivel2Bloq: Medalha_fabula_2_bloq,
      imgNivel3: Medalha_fabula_3,
      imgNivel3Bloq: Medalha_fabula_3_bloq,
    },
    Suspense: {
      imgNivel1: Medalha_suspense_1,
      imgNivel1Bloq: Medalha_suspense_1_bloq,
      imgNivel2: Medalha_suspense_2,
      imgNivel2Bloq: Medalha_suspense_2_bloq,
      imgNivel3: Medalha_suspense_3,
      imgNivel3Bloq: Medalha_suspense_3_bloq,
    },
  };

  const dados = medalhas[genero];

  return (
    <div>
      <div>
        <Modal
          open={open}
          onClose={onClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "25rem",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              width: "43rem",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              alignItems: "center",
              justifyContent: "center",
              gap: 3,
              borderRadius: "0.5rem",
            }}
          >
            <img
              onClick={onClose}
              src={Vector}
              style={{
                position: "relative",
                top: 0,
                left: "21.7rem",
                cursor: "pointer",
                width: "1.0rem",
                height: "1.0rem",
              }}
            />
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1.5rem",
                color: "var(--cor-preto)",
              }}
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Medalhas de {genero}
            </Typography>

            <Box sx={{ display: "flex", gap: 3 }}>
              <img
                style={{ width: "13.313rem", height: "16.25rem" }}
                src={nivel >= 1 ? dados.imgNivel1 : dados.imgNivel1Bloq}
              />
              <img
                style={{ width: "13.313rem", height: "16.25rem" }}
                src={nivel >= 2 ? dados.imgNivel2 : dados.imgNivel2Bloq}
              />
              <img
                style={{ width: "13.313rem", height: "16.25rem" }}
                src={nivel >= 3 ? dados.imgNivel3 : dados.imgNivel3Bloq}
              />
            </Box>

            <Box sx={{ justifyContent: "center", alignItems: "center" }}>
              {nivel < 3 ?(
                <Typography
                  id="modal-modal-description"
                  sx={{
                    mt: 2,
                    color: "var(--cor-pretoApoio)",
                    fontWeight: 400,
                    fontSize: "1.125rem",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                  }}
                >
                  Você precisa de:
                </Typography>
              ) : (
                <Typography
                  id="modal-modal-description"
                  sx={{
                    mt: 2,
                    color: "var(--cor-pretoApoio)",
                    fontWeight: 400,
                    fontSize: "1.125rem",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                  }}
                >
                  Parabéns!
                </Typography>
              )}

              <Box sx={{ width: "27.188rem", height: "2.375rem" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      color: "var(--cor-pretoApoio)",
                      fontWeight: 500,
                    }}
                  >
                    Nível {nivel}
                  </Typography>

                  <Typography
                    sx={{
                      color: "var(--cor-roxoEscuro)",
                      fontWeight: 500,
                      opacity: 1,
                    }}
                  >
                    <span
                      style={{
                        color:
                          pontuacao < 250
                            ? "var(--cor-cinzaApoio)"
                            : "var(--cor-roxoEscuro)",
                      }}
                    >
                      {pontuacao}
                    </span>
                    /{pontuacaoMax}
                  </Typography>
                </Box>
              </Box>

              <BarraDeProgresso
                pontuacao={pontuacao}
                pontuacaoMax={pontuacaoMax}
              />

              {nivel < 3 ? (
                <Typography
                  id="modal-modal-description"
                  sx={{
                    mt: 2,
                    color: "var(--cor-pretoApoio)",
                    fontStyle: "Regular",
                    fontWeight: 400,
                    fontSize: "1.125rem",
                    lineHeight: "100%",
                  }}
                >
                  para desbloquear a medalha{" "}
                  <span
                    style={{
                      fontStyle: "Medium",
                      fontWeight: 500,
                      fontSize: "1.125rem",
                      lineHeight: "100%",
                    }}
                  >
                    {genero}.
                  </span>
                </Typography>
              ) : (
                <Typography
                  id="modal-modal-description"
                  sx={{
                    mt: 2,
                    color: "var(--cor-pretoApoio)",
                    fontStyle: "Regular",
                    fontWeight: 400,
                    fontSize: "1.125rem",
                    lineHeight: "100%",
                  }}
                >
                  Você desbloqueou os 3 primeiros níveis! Continue lendo muio.
                </Typography>
              )}
            </Box>
          </Box>
        </Modal>
      </div>
    </div>
  );
}

export default Medalhas;
